import React, { useState, useEffect, useCallback, useRef } from 'react';
import './BalloonGame.css';
import balloonImage from './Images/balloons.png';
import popEffectImage from './Images/popeffect.png';
import popSound from './Sounds/Cartoon_balloon_popp.mp3';
import curtainCallAudio from './Sounds/simple_shade.mp3';
import hulkAudio from './Sounds/Hulk Mix6_Karaoke_Apr23_2024.mp3';
import rrAudio from './Sounds/Freeze keys frozen [2022-12-04 121225].mp3';
import curtainCallCover from './Images/sounds/CurtainCall.png';
import hulkCover from './Images/sounds/Hulk.png';
import rrCover from './Images/sounds/RR.png';
import background1 from './Images/Backgrounds/background1.png';
import background2 from './Images/Backgrounds/background2.png';
import background3 from './Images/Backgrounds/background3.png';
import background4 from './Images/Backgrounds/background4.png';
import background5 from './Images/Backgrounds/background5.png';
import background6 from './Images/Backgrounds/background6.png';
import background7 from './Images/Backgrounds/background7.png';
import background8 from './Images/Backgrounds/background8.png';
import background9 from './Images/Backgrounds/background9.png';
import background10 from './Images/Backgrounds/background10.png';
import ghostBalloon from './Images/Balloons/ghost.png';
import ghostThumbnail from './Images/Balloons/thumbnails/ghost.png';
import cloud1 from './Images/Balloons/clouds/cloud1.png';
import cloud2 from './Images/Balloons/clouds/cloud2.png';
import cloud3 from './Images/Balloons/clouds/cloud3.png';
import cloud4 from './Images/Balloons/clouds/cloud4.png';
import cloud5 from './Images/Balloons/clouds/cloud5.png';
import cloudThumbnail from './Images/Balloons/thumbnails/cloud.png';
import balloonsThumbnail from './Images/Balloons/thumbnails/balloons.png';
import freezeSound from './Sounds/Freeze keys frozen [2022-12-04 121225].mp3';
import shadeSound from './Sounds/simple_shade.mp3';

const backgrounds = [
  background1, background2, background3, background4, background5,
  background6, background7, background8, background9, background10
];

const cloudBalloons = [cloud1, cloud2, cloud3, cloud4, cloud5];

// Preload the default character sprite to speed up initial loading
const preloadDefaultCharacter = new Image();
preloadDefaultCharacter.src = 'https://www.daperformers.com/api/sprite/0';

function BalloonGame({ onBack }) {
  const [score, setScore] = useState(0);
  const [balloons, setBalloons] = useState([]);
  const [affirmation, setAffirmation] = useState('');
  const [poppedBalloons, setPoppedBalloons] = useState([]);
  const [isMuted, setIsMuted] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [characterId, setCharacterId] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [spriteLoadError, setSpriteLoadError] = useState(false);
  const [fallbackSprite, setFallbackSprite] = useState(null);
  const [spritePreloaded, setSpritePreloaded] = useState(false);
  const spriteImgRef = useRef(null);
  const [masterVolume, setMasterVolume] = useState(0.5);  // 50% default
  const [musicVolume, setMusicVolume] = useState(0.25);   // 25% default
  const [sfxVolume, setSfxVolume] = useState(0.5);        // 50% default
  const [userInfo, setUserInfo] = useState(null);
  const [currentMusic, setCurrentMusic] = useState('curtainCall');
  const [currentBackground, setCurrentBackground] = useState(4); // Index for background5
  const [currentBalloon, setCurrentBalloon] = useState('balloons');
  const [isCustomizeOpen, setIsCustomizeOpen] = useState(false);
  const audioRef = useRef(null);
  const popSoundRef = useRef(null);
  const [sessionScore, setSessionScore] = useState(0);
  const [allTimeScore, setAllTimeScore] = useState(0);
  const [username, setUsername] = useState('Player');
  const [userId, setUserId] = useState(null);
  const freezeAudioRef = useRef(null);
  const shadeAudioRef = useRef(null);
  const [availableSprites, setAvailableSprites] = useState([]);
  const [spritePage, setSpritePage] = useState(0);
  const [isSpriteLoading, setIsSpriteLoading] = useState(false);
  const SPRITES_PER_PAGE = 10;
  const [manualSpriteId, setManualSpriteId] = useState('');
  const spriteCacheRef = useRef({});
  const [totalSpritePages, setTotalSpritePages] = useState(1); // Track total pages available
  // Limit maximum number of balloons for performance
  const MAX_BALLOONS = 15;
  const MAX_POPPED_BALLOONS = 10;
  
  // List of affirmations to show when popping balloons
  const affirmations = [
    "Water and pray",
    "Gather seeds and plant later",
    "Look for 5 red items in the room",
    "Stand up and stretch your body",
    "Look for 5 brown items in the room",
    "Hurry, touch grass as fast as you can!",
    "Give gratitude",
    "Be like water",
    "You're awesome!",
    "You can do it!",
    "Believe in yourself!",
    "You're making progress!",
    "Keep going!",
    "He'll test you before he'll bless you!",
    "You said tomorrow yesterday...",
    "Every problem in your life is a blessing!",
    "You are stronger than you think!",
    "Success is on the horizon!",
    "Your potential is limitless!",
    "Every day is a new opportunity!",
    "You are capable of amazing things!",
    "Trust the process!",
    "Mistakes are proof you're trying!",
    "You are worthy of all the good things coming your way!",
    "The best is yet to come!",
    "Challenges help you grow!",
    "Your hard work is paying off!",
    "Keep shining, the world needs your light!",
    "Take 3 deep breaths",
    "Roll your neck for 5 seconds",
    "Walk to the nearest window and smile at the sky",
    "Say 3 things you love about yourself",
    "Pick up one piece of litter",
    "Lay on the floor and look up for 30 seconds",
    "Do 5 jumping jacks",
    "Drink a glass of water slowly",
    "Watch a plant breathe",
    "Blow air like wind through your lips",
    "Stretch your arms like branches",
    "Close your eyes and imagine a waterfall",
    "Touch something warm and something cold",
    "Listen for 3 different sounds",
    "Pretend you're a tree and root your feet to the ground",
    "Walk outside and find something soft",
    "Write your thoughts in the dirt or sand",
    "Name 3 things you're grateful for right now",
    "Tap your shoulders and say 'I got me'",
    "Whistle like a bird",
    "Let sun hit your skin (or imagine it)",
    "Slowly count down from 10 like a wave crashing",
    "Smile and hold it for 10 seconds",
    "Trace a leaf or something nearby with your finger"
  ];
  
  // Simple update score function that doesn't use Supabase
  const updateScore = useCallback((newScore) => {
    setScore(newScore);
    const newAllTimeScore = Math.max(newScore, allTimeScore);
    setAllTimeScore(newAllTimeScore);
  }, [allTimeScore]);

  const showAffirmation = () => {
    const randomIndex = Math.floor(Math.random() * affirmations.length);
    setAffirmation(affirmations[randomIndex]);
    setTimeout(() => setAffirmation(''), 3000);
  };

  // Then define callback functions that depend on the above utilities
  const playPopSound = useCallback(() => {
    if (isMuted || !popSoundRef.current) return;
    popSoundRef.current.currentTime = 0;
    popSoundRef.current.play().catch(error => console.log("Pop sound play failed:", error));
  }, [isMuted]);

  const playFreezeSound = useCallback(() => {
    if (isMuted || !freezeAudioRef.current) return;
    freezeAudioRef.current.currentTime = 0;
    freezeAudioRef.current.play().catch(err => console.error("Failed to play freeze sound:", err));
  }, [isMuted]);

  const playShadeSound = useCallback(() => {
    if (isMuted || !shadeAudioRef.current) return;
    shadeAudioRef.current.currentTime = 0;
    shadeAudioRef.current.play().catch(err => console.error("Failed to play shade sound:", err));
  }, [isMuted]);

  const spawnBalloon = useCallback(() => {
    setBalloons(prevBalloons => {
      // Limit the number of balloons for performance
      if (prevBalloons.length >= MAX_BALLOONS) {
        return prevBalloons;
      }
      
      const newBalloon = {
        id: Date.now(),
        x: Math.random() * (window.innerWidth - 160),
        y: -192,
        spawnTime: Date.now(),
        cloudImage: currentBalloon === 'cloud' ? cloudBalloons[Math.floor(Math.random() * cloudBalloons.length)] : null
      };
      return [...prevBalloons, newBalloon];
    });
  }, [currentBalloon]);

  const popBalloon = useCallback((id) => {
    setBalloons(prevBalloons => {
      const targetBalloon = prevBalloons.find(b => b.id === id);
      if (!targetBalloon) return prevBalloons;
      
      const currentTime = Date.now();
      const balloonsToRemove = prevBalloons.filter(balloon => 
        balloon.id === id || (Math.abs(balloon.spawnTime - targetBalloon.spawnTime) < 100)
      );
      
      // Limit the number of popped balloons for performance
      setPoppedBalloons(prev => {
        const newPopped = [...prev, ...balloonsToRemove.map(balloon => ({ 
          ...balloon, 
          poppedAt: currentTime 
        }))];
        
        // Only keep the most recent popped balloons
        return newPopped.slice(-MAX_POPPED_BALLOONS);
      });
      
      playPopSound();
      
      // Calculate the new score based on number of balloons popped
      const pointsEarned = balloonsToRemove.length;
      const newScore = score + pointsEarned;
      
      updateScore(newScore);
      showAffirmation();

      return prevBalloons.filter(balloon => !balloonsToRemove.includes(balloon));
    });
  }, [score, playPopSound, updateScore, showAffirmation]);

  const toggleMute = () => {
    setIsMuted(!isMuted);
    audioRef.current.muted = !isMuted;
  };

  const openModal = (content) => {
    // Use a timestamp as a unique key to prevent React key conflicts
    const modalKey = Date.now().toString();
    const contentWithKey = React.cloneElement(content, { key: modalKey });
    setModalContent(contentWithKey);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsCustomizeOpen(false);
  };

  const selectCharacter = useCallback((id) => {
    setIsModalOpen(false);
    
    // If we already have this sprite in cache, display immediately
    if (spriteCacheRef.current[id] && spriteCacheRef.current[id].loaded) {
      setCharacterId(id);
      setSpritePreloaded(true);
      spriteImgRef.current = spriteCacheRef.current[id].img;
      return;
    }
    
    // Otherwise show loading and set the ID
    setIsLoading(true);
    setCharacterId(id);
    
    // Loading will be handled by the preload effect
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, []);

  // Create a memoized fallback sprite to avoid recreation on each render
  const createFallbackSprite = useCallback(() => {
    const canvas = document.createElement('canvas');
    canvas.width = 192;
    canvas.height = 192;
    const ctx = canvas.getContext('2d');
    
    // Draw a simple character
    ctx.fillStyle = '#239063'; // Match the app's accent color
    ctx.fillRect(0, 0, 192, 192);
    
    // Add some details
    ctx.fillStyle = '#FFF';
    ctx.beginPath();
    ctx.arc(96, 60, 40, 0, Math.PI * 2);
    ctx.fill();
    
    ctx.fillStyle = '#000';
    ctx.beginPath();
    ctx.arc(80, 50, 5, 0, Math.PI * 2);
    ctx.arc(110, 50, 5, 0, Math.PI * 2);
    ctx.fill();
    
    ctx.strokeStyle = '#000';
    ctx.lineWidth = 3;
    ctx.beginPath();
    ctx.arc(96, 70, 20, 0.1 * Math.PI, 0.9 * Math.PI);
    ctx.stroke();
    
    return canvas.toDataURL();
  }, []);

  // Initialize fallback sprite on first render
  useEffect(() => {
    // Create and set fallback sprite immediately on component mount
    setFallbackSprite(createFallbackSprite());
  }, [createFallbackSprite]);

  // Then all the useEffect hooks
  // Initialize audio objects only once when component mounts
  useEffect(() => {
    audioRef.current = new Audio(curtainCallAudio);
    popSoundRef.current = new Audio(popSound);
    freezeAudioRef.current = new Audio(freezeSound);
    shadeAudioRef.current = new Audio(shadeSound);
    
    return () => {
      // Cleanup audio resources
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = '';
      }
      if (popSoundRef.current) {
        popSoundRef.current.pause();
        popSoundRef.current.src = '';
      }
      if (freezeAudioRef.current) {
        freezeAudioRef.current.pause();
        freezeAudioRef.current.src = '';
      }
      if (shadeAudioRef.current) {
        shadeAudioRef.current.pause();
        shadeAudioRef.current.src = '';
      }
    };
  }, []);

  useEffect(() => {
    if (!audioRef.current) return;
    
    audioRef.current.pause();
    audioRef.current.currentTime = 0;
    
    let audioSrc;
    switch(currentMusic) {
      case 'curtainCall':
        audioSrc = curtainCallAudio;
        break;
      case 'hulk':
        audioSrc = hulkAudio;
        break;
      case 'rr':
        audioSrc = rrAudio;
        break;
      default:
        audioSrc = curtainCallAudio;
    }
    
    audioRef.current.src = audioSrc;
    audioRef.current.loop = true;
    audioRef.current.volume = masterVolume * musicVolume;
    audioRef.current.play().catch(error => console.log("Audio play failed:", error));

    return () => {
      if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      }
    };
  }, [currentMusic, masterVolume, musicVolume]);

  useEffect(() => {
    if (popSoundRef.current) {
    popSoundRef.current.volume = sfxVolume;
    }
  }, [sfxVolume]);

  // Spawn new balloons at regular intervals
  useEffect(() => {
    const spawnInterval = setInterval(() => {
      if (balloons.length < MAX_BALLOONS) {
        spawnBalloon();
      }
    }, 1000);
    
    return () => clearInterval(spawnInterval);
  }, [balloons.length, spawnBalloon]);

  // Set up audio and mute status
  useEffect(() => {
    if (audioRef.current) {
    audioRef.current.muted = isMuted;
    }
    if (popSoundRef.current) {
    popSoundRef.current.muted = isMuted;
    }
  }, [isMuted]);

  // Preload the sprite image
  useEffect(() => {
    if (characterId === 0) {
      setSpritePreloaded(preloadDefaultCharacter.complete);
      if (!preloadDefaultCharacter.complete) {
        preloadDefaultCharacter.onload = () => setSpritePreloaded(true);
      }
    } else {
      setSpritePreloaded(false);
      const img = new Image();
      img.src = `https://www.daperformers.com/api/sprite/${characterId}`;
      img.onload = () => setSpritePreloaded(true);
    }
  }, [characterId]);
  
  // Setup default scores and values on initial load
  useEffect(() => {
    setScore(0);
    setAllTimeScore(0);
    setUsername('Player');
  }, []);

  // Optimized balloon movement
  useEffect(() => {
    const moveInterval = setInterval(() => {
      const currentTime = Date.now();
      setBalloons(prevBalloons => {
        // If no balloons, don't trigger a re-render
        if (prevBalloons.length === 0) return prevBalloons;
        
        return prevBalloons.map(balloon => {
          const elapsedTime = currentTime - balloon.spawnTime;
          const newY = -192 + (elapsedTime / 16); // Move 1 pixel every 16ms
          return {
            ...balloon,
            y: newY,
          };
        }).filter(balloon => balloon.y < window.innerHeight);
      });
    }, 16);

    return () => clearInterval(moveInterval);
  }, []);

  // Optimized popped balloon cleanup
  useEffect(() => {
    const cleanupInterval = setInterval(() => {
      setPoppedBalloons(prev => {
        // If no popped balloons, don't trigger a re-render
        if (prev.length === 0) return prev;
        
        return prev.filter(b => Date.now() - b.poppedAt < 550);
      });
    }, 100);

    return () => clearInterval(cleanupInterval);
  }, []);

  // Function to check if a sprite exists
  const checkSpriteExists = async (index) => {
    try {
      // For indices 0-101, always return true
      if (index >= 0 && index < 102) {
        return true;
      }
      
      // Check cache first
      if (spriteCacheRef.current[index] !== undefined) {
        return spriteCacheRef.current[index];
      }
      
      // For development, if we have CORS errors, just assume sprites 0-15 exist
      // This allows testing even when the sprite API is not accessible
      try {
        // Use no-cors mode to avoid CORS errors
        const spriteResponse = await fetch(`https://www.daperformers.com/api/sprite/${index}`, {
          mode: 'no-cors',
          method: 'HEAD'
        });
        
        // Since 'no-cors' responses have opaque response type, we can't access status
        // Instead, assume success if we didn't throw an error
        const exists = true;
        
        // Cache the result
        spriteCacheRef.current[index] = exists;
        return exists;
      } catch (fetchError) {
        // If fetch fails, fall back to assuming sprites 0-15 exist in development
        console.log(`Sprite fetch error for ${index}, using fallback logic:`, fetchError);
        const fallbackExists = index <= 15; // Assume first 16 sprites exist
        spriteCacheRef.current[index] = fallbackExists;
        return fallbackExists;
      }
    } catch (error) {
      console.log(`Error checking sprite ${index}:`, error);
      // Default to showing first 16 sprites in case of any error
      const fallbackExists = index <= 15;
      spriteCacheRef.current[index] = fallbackExists;
      return fallbackExists;
    }
  };

  // Improved sprite discovery system - check a wider range of sprites on mount
  useEffect(() => {
    let isMounted = true;
    
    const discoverTotalSprites = async () => {
      // Check for sprites at intervals to find the upper limit
      const checkPoints = [0, 10, 20, 50, 100, 150, 200, 300, 400, 500];
      let highestFound = 0;
      
      for (const point of checkPoints) {
        if (!isMounted) return;
        
        const exists = await checkSpriteExists(point);
        if (exists && point > highestFound) {
          highestFound = point;
        }
      }
      
      // Set the total number of pages based on highest sprite found
      if (isMounted && highestFound > 0) {
        const estimatedPages = Math.ceil(highestFound / SPRITES_PER_PAGE) + 1;
        setTotalSpritePages(estimatedPages);
      }
    };
    
    discoverTotalSprites();
    
    return () => {
      isMounted = false;
    };
  }, []);

  // Load available sprites with performance improvements
  useEffect(() => {
    let isMounted = true;
    
    const fetchAvailableSprites = async () => {
      if (!isMounted) return;
      
      setIsSpriteLoading(true);
      const availableIndexes = [];
      
      // Check in batches of 10 to avoid too many simultaneous requests
      const startIndex = spritePage * SPRITES_PER_PAGE;
      
      try {
        // Create an array of promises for checking sprites
        const checkPromises = [];
        for (let i = startIndex; i < startIndex + SPRITES_PER_PAGE; i++) {
          checkPromises.push(
            checkSpriteExists(i).then(exists => {
              if (exists && isMounted) {
                availableIndexes.push(i);
              }
              return exists;
            })
          );
        }
        
        // Wait for all checks to complete
        await Promise.all(checkPromises);
        
        if (isMounted) {
          setAvailableSprites(availableIndexes.sort((a, b) => a - b));
          setIsSpriteLoading(false);
        }
      } catch (error) {
        console.error("Error fetching sprites:", error);
        if (isMounted) {
          setIsSpriteLoading(false);
        }
      }
    };

    fetchAvailableSprites();
    
    return () => {
      isMounted = false;
    };
  }, [spritePage]); // Only re-run when page changes

  useEffect(() => {
    if (isCustomizeOpen) {
      openModal(<CustomizeContent />);
    }
  }, [currentMusic, currentBackground, currentBalloon, isCustomizeOpen]);

  // Improved preloading that caches sprites
  useEffect(() => {
    // Create an image element for preloading
    // If we have a cached sprite and it's loaded, use it
    if (
      spriteCacheRef.current[characterId] &&
      spriteCacheRef.current[characterId].loaded
    ) {
      setSpritePreloaded(true);
      spriteImgRef.current = spriteCacheRef.current[characterId].img;
      return;
    }
    
    // Initialize cache entry if not exists
    if (!spriteCacheRef.current[characterId]) {
      spriteCacheRef.current[characterId] = { loaded: false, img: null };
    }
    
    const preloadImage = new Image();
    
    // Reset error state when we try to load a new sprite
    setSpriteLoadError(false);
    setSpritePreloaded(false);
    
    // Handle successful sprite load
    preloadImage.onload = () => {
      setSpritePreloaded(true);
      spriteImgRef.current = preloadImage;
      
      // Update the cache
      spriteCacheRef.current[characterId] = { loaded: true, img: preloadImage };
    };
    
    // Handle sprite load error
    preloadImage.onerror = () => {
      setSpriteLoadError(true);
      setSpritePreloaded(false); // Not loaded, so UI will show blank
      
      // Remove any cached image for this ID
      spriteCacheRef.current[characterId] = { loaded: false, img: null };
    };
    
    // Start loading the sprite
    preloadImage.src = `https://www.daperformers.com/api/sprite/${characterId}`;
    
    // Cleanup function
    return () => {
      preloadImage.onload = null;
      preloadImage.onerror = null;
    };
  }, [characterId]);

  // Preload all available sprites in background
  useEffect(() => {
    if (availableSprites.length === 0) return;
    
    // Preload sprites in batches to avoid hammering the server
    const preloadSprites = async () => {
      const spritesToPreload = availableSprites.filter(id => !spriteCacheRef.current[id] || !spriteCacheRef.current[id].loaded);
      
      // Process in small batches
      const batchSize = 3;
      for (let i = 0; i < spritesToPreload.length; i += batchSize) {
        const batch = spritesToPreload.slice(i, i + batchSize);
        
        // Load this batch in parallel
        await Promise.all(batch.map(id => {
          return new Promise(resolve => {
            if (spriteCacheRef.current[id] && spriteCacheRef.current[id].loaded) {
              resolve();
              return;
            }
            
            const img = new Image();
            img.onload = () => {
              spriteCacheRef.current[id] = { loaded: true, img };
              resolve();
            };
            img.onerror = () => {
              // Don't store fallbacks here to avoid unnecessary image creation
              resolve();
            };
            img.src = `https://www.daperformers.com/api/sprite/${id}`;
          });
        }));
        
        // Small delay between batches to not overload
        if (i + batchSize < spritesToPreload.length) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }
      }
    };
    
    preloadSprites();
  }, [availableSprites]);

  // On component mount, pre-load sprite 0 and a few more common sprites
  useEffect(() => {
    if (!fallbackSprite) return; // Wait until fallback sprite is ready
    
    // Preload all sprites (0-101)
    const initialSprites = Array.from({ length: 102 }, (_, i) => i);
    
    initialSprites.forEach(id => {
      const img = new Image();
      img.onload = () => {
        spriteCacheRef.current[id] = { loaded: true, img };
        
        // If this is sprite 0, mark it as preloaded for initial display
        if (id === 0) {
          spriteImgRef.current = img;
          setSpritePreloaded(true);
        }
      };
      img.onerror = () => {
        // For errors on initial sprites, do nothing (no fallback)
      };
      img.src = `https://www.daperformers.com/api/sprite/${id}`;
    });
  }, [fallbackSprite]);

  // Define remaining helper functions that depend on callbacks

  // Function to change sprite page
  const changePage = (delta) => {
    const newPage = Math.max(0, spritePage + delta);
    setSpritePage(newPage);
  };

  // Handle manual sprite ID input
  const handleManualSpriteInput = (e) => {
    // Only allow numeric input
    const value = e.target.value.replace(/[^0-9]/g, '');
    setManualSpriteId(value);
  };

  // Handle manual sprite selection with improved error handling
  const handleManualSpriteSubmit = async () => {
    if (!manualSpriteId) return;
    
    const spriteId = parseInt(manualSpriteId, 10);
    setIsLoading(true);
    
    try {
      // Check if the sprite exists
      const exists = await checkSpriteExists(spriteId);
      
      if (exists) {
        setCharacterId(spriteId);
        closeModal();
      } else {
        // Create and append error message element
        const modalContent = document.querySelector('.modal-content');
        if (modalContent) {
          const message = document.createElement('div');
          message.className = 'error-message';
          message.textContent = `Sprite #${spriteId} not found`;
          modalContent.appendChild(message);
          
          // Remove the message after 3 seconds
    setTimeout(() => {
            if (message.parentNode) {
              message.parentNode.removeChild(message);
            }
          }, 3000);
        }
      }
    } catch (error) {
      console.error("Error selecting sprite:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Remaining UI render functions and handlers
  const getBalloonImage = useCallback((balloon) => {
    switch (currentBalloon) {
      case 'ghost':
        return ghostBalloon;
      case 'cloud':
        return balloon.cloudImage;
      default:
        return balloonImage; // Your original balloon image
    }
  }, [currentBalloon]);
  
  // The rest of the component...
  const selectDaPerformer = () => {
    openModal(
      <div>
        <h2>Select Da Performer</h2>
        <div className="modal-buttons">
          <button onClick={openCustomize}>Customize</button>
          <button onClick={openSettings}>Settings</button>
          <button onClick={closeModal}>Close</button>
        </div>
        {renderSpriteSelection()}
      </div>
    );
  };

  const handleVolumeChange = (setter) => (e) => {
    const value = parseFloat(e.target.value);
    setter(value);
    
    // Update actual audio elements
    if (setter === setMasterVolume) {
      // Master volume affects all sounds
      if (audioRef.current) {
        audioRef.current.volume = value * musicVolume;
      }
      if (popSoundRef.current) {
        popSoundRef.current.volume = value * sfxVolume;
      }
    } else if (setter === setMusicVolume) {
      // Music volume
      if (audioRef.current) {
        audioRef.current.volume = masterVolume * value;
      }
    } else if (setter === setSfxVolume) {
      // SFX volume
      if (popSoundRef.current) {
        popSoundRef.current.volume = masterVolume * value;
      }
    }
  };

  const handleSliderClick = (setter) => (e) => {
    const sliderRect = e.currentTarget.getBoundingClientRect();
    const clickPosition = e.clientX - sliderRect.left;
    const sliderWidth = sliderRect.width;
    const newValue = Math.max(0, Math.min(1, clickPosition / sliderWidth));
    setter(newValue);
  };

  const openSettings = () => {
    openModal(
      <div className="options-menu">
        <h2>Da Settings</h2>
        <div className="volume-controls">
          <h3>Da Volume</h3>
          <div className="volume-slider">
            <label>Master</label>
            <input 
              type="range" 
              min="0" 
              max="1" 
              step="0.01" 
              value={masterVolume} 
              onChange={handleVolumeChange(setMasterVolume)} 
              className="custom-slider"
            />
            <span>{Math.round(masterVolume * 100)}%</span>
          </div>
          <div className="volume-slider">
            <label>Music</label>
            <input 
              type="range" 
              min="0" 
              max="1" 
              step="0.01" 
              value={musicVolume} 
              onChange={handleVolumeChange(setMusicVolume)} 
              className="custom-slider"
            />
            <span>{Math.round(musicVolume * 100)}%</span>
          </div>
          <div className="volume-slider">
            <label>SFX</label>
            <input 
              type="range" 
              min="0" 
              max="1" 
              step="0.01" 
              value={sfxVolume} 
              onChange={handleVolumeChange(setSfxVolume)} 
              className="custom-slider"
            />
            <span>{Math.round(sfxVolume * 100)}%</span>
          </div>
        </div>
        <div className="credits">
          <h3>Da Credits</h3>
          <p>Produced by <a href="https://x.com/DaCirkus" className="yellow-link">Da Cirkus</a></p>
          <p>Customize your own character -&gt; <a href="https://www.DaPerformers.com" className="green-link">www.DaPerformers.com</a></p>
        </div>
        <div className="modal-buttons">
          <button onClick={selectDaPerformer}>Back</button>
          <button onClick={closeModal}>Close</button>
          <button onClick={onBack}>Main Menu</button>
        </div>
      </div>
    );
  };

  const CustomizeContent = () => (
    <div className="customize-menu">
      <h2>Customize</h2>
      <div className="customize-section">
        <h3>Da Sound</h3>
        <div className="sound-options">
          <div 
            className={`sound-option ${currentMusic === 'curtainCall' ? 'selected' : ''}`}
            onClick={() => setCurrentMusic('curtainCall')}
          >
            <img src={curtainCallCover} alt="Curtain Call" />
            <p>Curtain Call</p>
          </div>
          <div 
            className={`sound-option ${currentMusic === 'hulk' ? 'selected' : ''}`}
            onClick={() => setCurrentMusic('hulk')}
          >
            <img src={hulkCover} alt="HULK" />
            <p>HULK</p>
          </div>
          <div 
            className={`sound-option ${currentMusic === 'rr' ? 'selected' : ''}`}
            onClick={() => setCurrentMusic('rr')}
          >
            <img src={rrCover} alt="RR" />
            <p>RR</p>
          </div>
        </div>
      </div>
      <div className="customize-section">
        <h3>Da Balloons</h3>
        <div className="balloon-options">
          <div 
            className={`balloon-option ${currentBalloon === 'balloons' ? 'selected' : ''}`}
            onClick={() => setCurrentBalloon('balloons')}
          >
            <img src={balloonsThumbnail} alt="Balloons" />
            <p>Balloons</p>
          </div>
          <div 
            className={`balloon-option ${currentBalloon === 'ghost' ? 'selected' : ''}`}
            onClick={() => setCurrentBalloon('ghost')}
          >
            <img src={ghostThumbnail} alt="Ghost Balloons" />
            <p>Ghost</p>
          </div>
          <div 
            className={`balloon-option ${currentBalloon === 'cloud' ? 'selected' : ''}`}
            onClick={() => setCurrentBalloon('cloud')}
          >
            <img src={cloudThumbnail} alt="Cloud Balloons" />
            <p>Cloud</p>
          </div>
        </div>
      </div>
      <div className="customize-section">
        <h3>Da Background</h3>
        <div className="background-options">
          {backgrounds.map((bg, index) => (
            <div 
              key={index}
              className={`background-option ${currentBackground === index ? 'selected' : ''}`}
              onClick={() => setCurrentBackground(index)}
            >
              <img src={bg} alt={`Background ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>
      <div className="modal-buttons">
        <button onClick={selectDaPerformer}>Back</button>
        <button onClick={closeModal}>Close</button>
      </div>
    </div>
  );

  const openCustomize = () => {
    setIsCustomizeOpen(true);
    openModal(<CustomizeContent />);
  };

  // Generate sprite buttons for each page - with fixed set of 102 buttons
  const renderSpriteButtons = () => {
    const buttons = [];
    // Display fixed set of buttons from 0-101
    for (let i = 0; i < 102; i++) {
      // Make all buttons available (0-101)
      const isAvailable = true;
      
      buttons.push(
        <button 
          key={i} 
          onClick={() => isAvailable && selectCharacter(i)}
          className={`sprite-button ${characterId === i ? 'selected' : ''} ${isAvailable ? 'available' : 'unavailable'}`}
          disabled={!isAvailable}
        >
          {i}
        </button>
      );
    }
    
    return buttons;
  };

  const renderSpriteSelection = () => {
    return (
      <div className="sprite-selection">
        <h3>Browse Available Characters</h3>
        {isSpriteLoading ? (
          <div className="loading-animation"></div>
        ) : (
          <div className="character-options">
            {renderSpriteButtons()}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="game-container" style={{backgroundImage: `url(${backgrounds[currentBackground]})`}}>
      {balloons.map(balloon => (
        <div
          key={`balloon-${balloon.id}`}
          className={`balloon ${currentBalloon}`}
          style={{
            left: `${balloon.x}px`,
            bottom: `${balloon.y}px`,
            backgroundImage: `url(${getBalloonImage(balloon)})`,
          }}
          onClick={() => popBalloon(balloon.id)}
        />
      ))}
      {poppedBalloons.map(balloon => (
        <div
          key={balloon.id}
          className="balloon-pop"
          style={{
            left: `${balloon.x}px`,
            bottom: `${balloon.y}px`,
          }}
        />
      ))}
      <div className="character-platform">
        <div 
          className="character" 
          style={{
            backgroundImage: (preloadDefaultCharacter.complete && characterId === 0 && !spritePreloaded)
              ? `url(${preloadDefaultCharacter.src})`
              : (spritePreloaded ? `url(https://www.daperformers.com/api/sprite/${characterId})` : 'none'),
            visibility: (preloadDefaultCharacter.complete && characterId === 0) || spritePreloaded ? 'visible' : 'hidden'
          }}
        ></div>
        {!spritePreloaded && !(preloadDefaultCharacter.complete && characterId === 0) && (
          <div className="loading-animation character-loading"></div>
        )}
        <div className="score">Score: {score}</div>
        <button className="da-performer-button" onClick={selectDaPerformer}>Da Performer</button>
      </div>
      {affirmation && (
        <div className="affirmation-overlay">
          <div className="popped-affirmation">{affirmation}</div>
        </div>
      )}
      {isModalOpen && (
        <div className="modal">
          <div className="modal-content">
            {modalContent}
          </div>
        </div>
      )}
      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-animation"></div>
        </div>
      )}
      <button className="mute-button" onClick={toggleMute}>
        {isMuted ? 'Unmute' : 'Mute'}
      </button>
    </div>
  );
}

export default BalloonGame;
